import { render, staticRenderFns } from "./BaseLearningResponsesEdit.vue?vue&type=template&id=5f64c270&scoped=true&"
import script from "./BaseLearningResponsesEdit.vue?vue&type=script&lang=js&"
export * from "./BaseLearningResponsesEdit.vue?vue&type=script&lang=js&"
import style0 from "./BaseLearningResponsesEdit.vue?vue&type=style&index=0&id=5f64c270&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f64c270",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VRow,VSheet,VTextField})
